<ng-container *ngIf="ifTipsEnabled">
	<ion-row class="tip-component" role="region" aria-label="Tip component">
		<ion-col class="ion-no-padding">
			<ion-row class="title-row" role="region" aria-label="Title section">
				<ion-col class="ion-no-padding titles-wrapper" size="12">
					<h5 class="title">
						{{ 'tip_component.title' | translate }}
					</h5>
					<p class="chip" *ngIf="customTipsEnter" (click)="showCustomPicker()">
						{{ 'tip_component.custom' | translate }}
					</p>
				</ion-col>
			</ion-row>
			<ion-row class="tip-row" role="region" aria-label="Tip section">
				<!-- " -->
				<ion-col
					(click)="select(percent)"
					*ngFor="let percent of tipsValues"
					class="tip"
					[class.selected]="percent.value === selectedPercent?.value && percent.type === selectedPercent?.type"
				>
					<p class="sum">{{ mapTipsEnumToValue(percent) }}</p>
				</ion-col>
				<ion-col (click)="this.customTip = 0" *ngIf="customTip" class="tip" [class.selected]="customTip">
					<p class="sum">+{{ numberToCurrency(customTip, currency) }}</p>
				</ion-col>
			</ion-row>
		</ion-col>
	</ion-row>
</ng-container>
